import { Box, Typography } from '@mui/material';

import { FORTA_ORANGE, FORTA_WHITE } from '../../utils/colors';

interface WarningPoperProps {
  message: string;
  sx?: any;
}

function FWarningPoper(props: WarningPoperProps) {
  const { message, sx } = props;

  return (
    <Box
      sx={{
        width: 'auto',
        height: 30,
        backgroundColor: FORTA_ORANGE,
        filter: 'drop-shadow(0px 4px 4px rgba(18, 78, 120, 0.25))',
        display: 'inline-block',
        float: 'left',
        borderRadius: '10px ',
        padding: '0 0.5em',
        mb: 2,
        position: 'absolute',
        top: -44,
        left: 0,

        '&::before': {
          content: "''",
          position: 'absolute',
          top: 30,
          left: 15,
          borderColor: 'transparent',
          borderTop: `8px solid ${FORTA_ORANGE}`,
          borderBottom: '8px solid transparent',
          borderLeft: '5px solid transparent',
          borderRight: '5px solid transparent',
          zIndex: 100,
        },
        ...sx,
      }}
    >
      <Typography color={FORTA_WHITE} textAlign="left" sx={{ height: '100%', lineHeight: 1.8 }}>
        {message}
      </Typography>
    </Box>
  );
}

export default FWarningPoper;
